import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const loginWithGoogleCredential = useCallback(async (credential) => {
    const res = await api.post("/auth/google-login", { credential });
    setUser(res.data);
    window.location.href = "/dashboard";
  }, []);

  const login = async () => {
    const code = window.prompt("AI Marka Radar giriş kodunu yaz:");
    if (!code) return;

    try {
      const res = await api.post("/auth/local-login", {}, {
        headers: { "X-Admin-Login-Code": code }
      });
      setUser(res.data);
      window.location.href = "/dashboard";
    } catch {
      alert("Giriş kodu hatalı veya sunucuya ulaşılamıyor.");
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(null);
    window.location.href = "/";
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, checkAuth, login, loginWithGoogleCredential, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
